import React from "react";
import { Card } from "@sscs/ui";
import { capitalizeFirstLetter } from "@sscs/utils";
import { EFFORT_TO_ESTIMATE } from "../../../constants";
import { EffortTooltip, RemediationSteps } from "../../../ui";
import styles from "./policyRecommendation.module.scss";
export const calculateEffortEstimate = (effort, violationCount) => {
    return Math.ceil((violationCount * EFFORT_TO_ESTIMATE[effort]) / 8);
};
const PolicyRecommendation = ({ recommendation, effort, violationCount, }) => {
    var _a;
    const estimateInDays = calculateEffortEstimate(effort, violationCount);
    if (!recommendation || !recommendation.problem)
        return (React.createElement(Card.Card, null,
            React.createElement(Card.Title, null, "Problem"),
            React.createElement(Card.Content, { className: styles["no-recommendation"] }, "No recommendation")));
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, null, "Problem"),
        React.createElement(Card.Content, null,
            React.createElement("span", null, recommendation.problem),
            React.createElement("div", { className: styles["estimate-title"] },
                React.createElement("span", { className: styles["estimate-label"] }, "Estimate"),
                React.createElement(EffortTooltip, { estimateInDays: estimateInDays, effort: effort, violationCount: violationCount })),
            React.createElement("span", null,
                capitalizeFirstLetter(effort),
                " effort =",
                " ",
                estimateInDays.toLocaleString(),
                " working day",
                estimateInDays !== 1 ? "s" : ""),
            React.createElement("div", { className: styles["next-steps-title"] }, "Next steps"),
            React.createElement(RemediationSteps, { steps: (_a = recommendation.nextSteps) !== null && _a !== void 0 ? _a : [] }))));
};
export default PolicyRecommendation;
//# sourceMappingURL=PolicyRecommendation.js.map